import { helper } from '@ember/component/helper';
import { get } from '@ember/object';

/**
 * A report template component's heading: the school's custom heading
 * (customLabel) where set, otherwise the component's default label.
 *
 * Read through Ember's get so the helper reruns when the report builder
 * sets customLabel on a plain component object.
 *
 * Usage: {{reporting/component-heading comp}}
 */
export function componentHeading(component) {
  if (!component) return '';
  // eslint-disable-next-line ember/no-get
  return get(component, 'customLabel') || get(component, 'label') || '';
}

export default helper(function ([component]) {
  return componentHeading(component);
});
